const api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl`;

export default {
    authenticated() {
        const that = this;

        // Return new promise
        return new Promise(function (resolve, reject) {
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    // Parse JSON response
                    if (json.result.match(/^OK/i)) {
                        // Store user in sessions
                        sessionStorage.setItem('user', JSON.stringify({
                            avatar: json.avatar || '',
                            buildings: json.buildings || [],
                            commonName: json.commonName || '',
                            department: json.department || '',
                            isResidenceAssistant: json.isResidenceAssistant || '0',
                            permissions: json.permissions || {},
                            rootGroupUser: json.rootGroupUser || '',
                            sessionType: json.sessionType || '',
                            sex: json.sex || '',
                            username: json.username || ''
                        }));

                        // Return success
                        resolve(true);
                    } else {
                        // Destroy session
                        that.logout();

                        // Check if user is authenticated but unauthorized
                        if (json.message.match(/^UNAUTHORIZED/i)) {
                            sessionStorage.setItem('user', JSON.stringify({
                                sessionType: 'unauthorized'
                            }));

                            // Return warning
                            resolve(false);
                        } else {
                            // Return failure
                            reject(false);
                        }
                    }
                })
                .catch(function () {
                    // Destroy session
                    that.logout();
                    reject(false);
                })
        })
    },
    authorized() {
        let user = JSON.parse(sessionStorage.getItem('user'));

        // Check if user session is unauthorized
        if (user && user.sessionType && user.sessionType == 'unauthorized') {
            return false;
        }

        return true;
    },
    hasPermission(permission) {
        let user = this.getUser();
        let permissions = user.permissions || {};

        // Resolve admin permissions
        if (user.rootGroupUser == "1") {
            return true;
        }

        // Check if permission exists and is enabled
        if (permissions[permission] && permissions[permission].enabled == "1") {
            return true;
        }

        return false;
    },
    getPermission(permission) {
        let user = this.getUser();
        let permissions = user.permissions || {};

        if (user.rootGroupUser == "1") {
            return {
                access: "write",
                enabled: "1"
            }
        }

        return permissions[permission] || {
            access: "",
            enabled: "0"
        };
    },
    isAdmin() {
        let user = JSON.parse(sessionStorage.getItem('user'));

        // Check if user session is admin
        if (user && user.sessionType && user.sessionType == 'admin') {
            return true;
        }

        return false;
    },
    logout() {
        // Destroy session storage
        sessionStorage.clear();
    },
    getUser() {
        // Return user
        return JSON.parse(sessionStorage.getItem('user'));
    }
}